var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"headerBg"},[_c('v-header')],1),_c('div',{staticClass:"main"},[_c('v-main')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }